exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{border-color:red!important;background:#fdd}.successful{-webkit-box-shadow:5px 5px 10px rgba(0,160,133,.7)!important;-moz-box-shadow:5px 65px 10px rgba(0,160,133,.7)!important;box-shadow:5px 5px 10dpx rgba(0,160,133,.7)!important}.error:focus{outline-color:#f99}.text-orange{color:#f59019;font-weight:700}.nice-select .current{width:-webkit-fill-available!important;display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.shadow{box-shadow:10px 10px 40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-efee8086","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/GrayZone/Reference.vue
// module id = 769
// module chunks = 0